// extracted by mini-css-extract-plugin
export var legendIndicator = "_8x-1";
export var legendRight = "_8x-0";